<template>

  <v-dialog
    v-model="dialog"
    width="70%"
    max-width="1000px"
    transition="dialog-bottom-transition"
  >

    <v-card class="col-12 pa-0" v-if="init">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Benefit {{ item.benefit_id ? '#' + item.benefit_id : '' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})">
          <v-btn
            text
            :loading="loading"
            @click="save()"
          >
            Save
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container class="px-5 overflow-auto" :style="`height: calc(100vh - 180px - ${!$store.state.auth.default_user ? '0px' : '24px'} + ${$vuetify.breakpoint.name == 'sm' ? '50px' : '0px'})`">
        <v-row class="ma-0">
          <select-project
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            v-model="item.entity_id"
          ></select-project>
        </v-row>

        <v-row>
          <v-text-field
            label="Title"
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            :prefix="item.benefit_id ? '#' + item.benefit_id : null"
            v-model="item.name"
            class="col-4"
          />
          <v-text-field
            label="Alias"
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            v-model="item.alias"
            class="col-4"
          />

          <v-select
            label="Type"
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            class="col-4"
            :items="select.types"
            v-model="item.type"
          />

          <!--          <v-text-field-->
          <!--            label="Email Notification"-->
          <!--            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"-->
          <!--            v-model="item.email"-->
          <!--            class="col-4"-->
          <!--          />-->
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-select
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            label="Mail Template"
            :items="mail_templates"
            v-model="item.mail_templates"
            class="col-6  pl-0"
            multiple
          >
            <template v-slot:selection="{ item: chipItem, index }">
              <div style="max-width: 180px" class="v-select__selection v-select__selection--comma" v-if="index < chipCount">{{ chipItem.text || chipItem }}{{ index < chipCount - 1 ? ',' : '' }} &nbsp;</div>
              <span
                class="caption float-right"
                v-if="index === chipCount && (item.mail_templates || []).length > chipCount"
              >(+{{ (item.mail_templates || []).length - chipCount }} others)</span>
            </template>
          </v-select>

          <v-text-field
            label="Start"
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            class="col-3"
            v-model="item.start"
            :rules="[v => !!v || 'Date Start is required']"
            placeholder="Format: YYYY-MM-DD HH:mm:ss (eg: 2020-01-01 00:00:00)"
            v-mask="`####-##-## ##:##:##`"
            required
          />
          <v-text-field
            label="End"
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            class="col-3 pr-0"
            v-model="item.end"
            :rules="[v => !!v || 'Date End is required']"
            placeholder="Format: YYYY-MM-DD HH:mm:ss (eg: 2020-10-29 23:59:59)"
            v-mask="`####-##-## ##:##:##`"
            required
          />
        </v-row>

        <fieldset class="px-2 pb-2 group-border">
          <legend class="px-2">
            Users segment filter
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              icon
              @click="item.segments.push({})"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </legend>
          <small class="legend-description">Only users meeting these criteria will see those bonuses as available</small>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Type</th>
                  <th class="text-left">Equation</th>
                  <th class="text-left">Value</th>
                  <th class="text-left">
                    <v-btn
                      v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      icon
                      @click="item.segments.push({})"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(segment, i) in item.segments" :key="'segment-' + i">
                  <td>{{ i + 1 }}</td>
                  <td class="col-4">
                    <v-select
                      :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      class="mt-0 pt-0"
                      v-model="segment.field"
                      :items="select.fields"
                      hide-details
                    />
                  </td>
                  <td class="col-4">
                    <v-select
                      :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      class="mt-0 pt-0"
                      v-model="segment.equation"
                      :items="select.equations"
                      hide-details
                    />
                  </td>
                  <td class="col-3">
                    <v-text-field
                      :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      class="mt-0 pt-0"
                      v-model="segment.value"
                      hide-details
                    />
                  </td>
                  <td>
                    <v-btn
                      v-if="item.segments.length != 1 && $store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      class="my-auto"
                      icon
                      @click="item.segments.splice(i, 1)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </fieldset>

        <fieldset v-if="item.repeat" class="px-2 pb-2 mt-7 group-border">
          <legend class="px-2">
            Repeat
          </legend>
          <small class="legend-description">Use a comma to separate days</small>

          <v-row class="mx-0 mt-3">
            <v-select
              label="Period"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              :class="{'mt-0': true, 'pt-0': true, 'col-4' : days.length > 0 , 'col-6': days.length == 0}"
              v-model="item.repeat.period"
              :items="select.periods"
              hide-details
            />
            <v-select
              label="Days"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              v-if="days.length > 0"
              :class="{'mt-0': true, 'pt-0': true, 'col-4' : days.length > 0 }"
              v-model="item.repeat.days"
              :items="days"
              multiple
              hide-details
            />
            <v-text-field
              label="On Time"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              :class="{'mt-0': true, 'pt-0': true, 'col-4' : days.length > 0 , 'col-6': days.length == 0}"
              v-model="item.repeat.time"
              v-mask="`##:##:##`"
              placeholder="HH:mm:ss"
              hide-details
            />
          </v-row>
        </fieldset>

        <fieldset v-if="item.conditions" class="px-2 pb-2 mt-7 group-border">
          <legend class="px-2">
            Conditions
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              icon
              @click="item.conditions.push({})"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </legend>
          <small class="legend-description">The benefit will be issued only for players who meet these criteria</small>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Type</th>
                  <th class="text-left">Equation</th>
                  <th class="text-left">Value</th>
                  <th class="text-left">
                    <v-btn
                      v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      icon
                      @click="item.conditions.push({})"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(condition, i) in item.conditions" :key="'condition-' + i">
                  <td>{{ i + 1 }}</td>
                  <td class="col-4">
                    <v-select
                      class="mt-0 pt-0"
                      :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      v-model="condition.field"
                      :items="select.fields"
                      hide-details
                    />
                  </td>
                  <td class="col-4">
                    <v-select
                      class="mt-0 pt-0"
                      :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      v-model="condition.equation"
                      :items="select.equations"
                      hide-details
                    />
                  </td>
                  <td class="col-3">
                    <v-text-field
                      :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      class="mt-0 pt-0"
                      v-model="condition.value"
                      hide-details
                    />
                  </td>
                  <td>
                    <v-btn
                      v-if="item.conditions.length != 1 && $store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                      class="my-auto"
                      icon
                      @click="item.conditions.splice(i, 1)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </fieldset>

        <fieldset v-if="item.cashback" class="px-2 pb-2 mt-7 group-border">
          <legend class="px-2">
            Cashback
          </legend>

          <v-row class="mx-0 mt-3">

            <v-text-field
              label="Percent"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              class="mt-0 pt-0 col-3"
              type="number"
              v-model="item.cashback.percent"
              hide-details
            />
            <v-select
              label="For Period"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              class="mt-0 pt-0 col-3"
              v-model="item.cashback.for_period"
              :items="select.for_period"
              hide-details
            />
            <v-text-field
              label="Minimal sum EUR"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              class="mt-0 pt-0 col-3"
              type="number"
              v-model="item.cashback.min"
              hide-details
            />
            <v-text-field
              label="Maximum sum EUR"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              class="mt-0 pt-0 col-3"
              type="number"
              v-model="item.cashback.max"
              hide-details
            />
          </v-row>
        </fieldset>

        <fieldset v-if="item.recurring" class="px-2 pb-2 mt-7 group-border">
          <legend class="px-2">
            Recurring
          </legend>
          <small class="legend-description">The period when this achievement can be triggered again</small>
          <v-select
            label="For Period"
            :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
            class="mt-5 pt-0 mb-2"
            v-model="item.recurring"
            :items="select.recurring"
            hide-details
          />
        </fieldset>

        <fieldset v-if="item.steps" class="px-2 pb-2 mt-7 group-border">
          <legend class="px-2">
            {{ stepsTitle }}
            <v-btn
              v-if="stepsTitle.toLowerCase() == 'steps' && $store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              icon
              @click="item.steps.push({conditions: [{}]})"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </legend>

          <v-container class="mx-0 col-12 pb-7 pt-0" v-for="(step, s) in item.steps" :key="'step-' + s">
            <v-divider v-if="0 != s" class="mt-3 steps-divider" />

            <v-select
              label="Trigger"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              :items="select.triggers"
              v-model="item.steps[s].trigger"
              hide-details
              class="mb-3"
            />

            <v-text-field
              label="Triggers count"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              v-model="item.steps[s].count"
              hint="How many times needs to be triggered until completion"
              persistent-hint
              class="mb-3"
            />

            <v-select
              label="Count Period"
              :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              class="mb-3"
              v-model="item.steps[s].count_period"
              :items="select.count_period"
              hide-details
            />

            <v-simple-table class="mt-5">
              <template v-slot:default>
                <caption class="text-left">
                  Trigger conditions
                  <small class="legend-description mt-0">Event will count only if it meets these criteria</small>
                </caption>
                <thead>
                  <tr>
                    <th class="text-left">#</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Equation</th>
                    <th class="text-left">Value</th>
                    <th class="text-left">
                      <v-btn
                        v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                        icon
                        @click="item.steps[s].conditions.push({})"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(condition, i) in item.steps[s].conditions" :key="'conditions-' + i + '-' + s">
                    <td>{{ i + 1 }}</td>
                    <td class="col-4">
                      <v-select
                        :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                        class="mt-0 pt-0"
                        v-model="condition.field"
                        :items="select.fields"
                        hide-details
                      />
                    </td>
                    <td class="col-4">
                      <v-select
                        :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                        class="mt-0 pt-0"
                        v-model="condition.equation"
                        :items="select.equations"
                        hide-details
                      />
                    </td>
                    <td class="col-3">
                      <v-text-field
                        :readonly="!$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                        class="mt-0 pt-0"
                        v-model="condition.value"
                        hide-details
                      />
                    </td>
                    <td>
                      <v-btn
                        v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                        class="my-auto"
                        icon
                        @click="item.steps[s].conditions.splice(i, 1)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>


            <v-row class="mx-0 mt-3 pa-0">
              <v-spacer />
              <v-btn
                v-if="s != 0 && $store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                small
                color="info"
                class="my-auto"
                @click="item.steps.splice(s, 1)"
              >
                Remove step
                <v-icon small>delete</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </fieldset>

        <fieldset class="px-2 pb-2 group-border mt-7">
          <legend class="px-2">
            Bonus choice
            <v-btn
              v-if="item.type != 'cashback' && $store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
              icon
              @click="item.bonus.push([])"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </legend>
          <small class="legend-description">Player should choose one of the bonuses</small>

          <v-row class="pa-0 ma-0" v-for="(bonuses, i) in item.bonus" v-if="item.bonus[i] != null" :key="'bonus-choice-' + i">
            <bonus-form v-for="(bonus, k) in item.bonus[i]" v-if="item.bonus[i][k]" v-model="item.bonus[i][k]" :key="bonus.id" :type="item.type" :count="filter(item.bonus[i], o => !!o).length" />

            <v-row class="col-12 ma-0" v-if="item.type != 'cashback'">
              <v-btn
                v-if="item.bonus.length > 1 && $store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                small
                color="warning"
                @click="removeBonusChoice(i)"
              >
                Remove bonus choice
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
                small
                color="info"
                @click="addBonus(i)"
              >
                Add bonus
                <v-icon small>add</v-icon>
              </v-btn>
            </v-row>

            <v-divider class="col-12" />
          </v-row>

        </fieldset>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<style>
  .group-border {
    border-color: #d7dde4;
    border-radius: 6px;
  }

  .legend-description {
    color: #646970;
    margin-top: -7px;
    display: block;
  }

  .steps-divider {
    border-color: #d7dde4;
    border-style: groove;
    margin-left: -21px;
    max-width: calc(100% + 42px);
    width: calc(100% + 42px);
  }
</style>

<script>
  import { map, cloneDeep, find, get, filter, remove } from 'lodash'
  import BonusForm from '@/components/bonus-tools/BonusForm'
  import Vue from 'vue'
  import moment from 'moment'

  import { mask } from 'vue-the-mask'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    directives: {
      mask,
    },
    props: [ 'init', 'value' ],
    components: { SelectProject, BonusForm },

    data: () => ({
      chipCount: 1,
      loading: false,
      forID: 1,
      select: {
        count_period: [
          { text: 'Once', value: 'once' },
          { text: 'Minute', value: 'minute' },
          { text: 'Hour', value: 'hour' },
          { text: '24 hours', value: '24hours' },
          { text: 'Next day on 12pm UTC', value: 'day' },
          { text: 'Week', value: 'week' },
          { text: 'Month', value: 'month' },
        ],
        recurring: [
          { text: 'Never', value: 'none' },
          { text: '1 Minute', value: 'minute' },
          { text: '1 Hour', value: 'hour' },
          { text: '24 hours', value: '24hours' },
          { text: 'Next day on 12pm UTC', value: 'day' },
          { text: 'Next week', value: 'week' },
          { text: 'Next month', value: 'month' },
        ],
        periods: [
          { text: 'Daily', value: 'daily' },
          { text: 'Weekly', value: 'weekly' },
          { text: 'Monthly', value: 'monthly' },
          {
            text: 'Weekdays', value: 'weekdays', additional: [
              { text: 'Monday', value: 1 },
              { text: 'Tuesday', value: 2 },
              { text: 'Wednesday', value: 3 },
              { text: 'Thursday', value: 4 },
              { text: 'Friday', value: 5 },
              { text: 'Saturday', value: 6 },
              { text: 'Sunday', value: 7 }
            ]
          },
          { text: 'Month days', value: 'month_days', additional: Array.from({ length: 31 }, (_, i) => i + 1) },
          { text: 'Once', value: 'once' },
        ],
        for_period: [
          { text: 'Last day', value: 'day' },
          { text: 'Last week', value: 'week' },
          { text: 'Last month', value: 'month' },
          { text: 'Last year', value: 'year' },
        ],
        types: [
          { text: 'Period', value: 'period' },
          { text: 'Autobonus', value: 'autobonus' },
          { text: 'Promotional', value: 'promo' },
          { text: 'Cashback', value: 'cashback' },
          { text: 'Retention', value: 'retention' },
          { text: 'Achievement', value: 'achievement' },
          { text: 'Journey', value: 'journey' },
        ],
        fields: [
          { value: 'deposit.count', text: 'Deposit count' },
          { value: 'deposit.amount', text: 'Deposit amount' },
          { value: 'account.type', text: 'Account type' },
          { value: 'account.country', text: 'Account country' },
          { value: 'account.language', text: 'Account language' },
          { value: 'account.currency', text: 'Account currency' },
          { value: 'account.affiliate', text: 'Affiliate' },
          { value: 'account.btag', text: 'B-Tag' },
          { value: 'account.level', text: 'VIP Level' },
          { value: 'account.unfunded', text: 'Unfunded days' },
        ],
        equations: [
          { value: '=', text: 'Equal to' },
          { value: '!=', text: 'Not Equal to' },
          { value: '>', text: 'More than' },
          { value: '<', text: 'Less than' },
          { value: '>=', text: 'More or equal to' },
          { value: '<=', text: 'Less or equal to' },
        ],
        triggers: [
          { value: 'registration', text: 'Registration' },
          { value: 'login', text: 'Login' },
          { value: 'deposit', text: 'Deposit' },
          { value: 'unfunded', text: 'Unfunded' },
          { value: 'new_level', text: 'New VIP Level' },
          { value: 'idle', text: 'IDLE' },
        ],
      },

      item: {},

      itemInit: {
        benefit_id: null,
        title: '',
        type: '',
        start: null,
        end: null,
        segments: [ {} ],
        bonus: [ [ {} ] ],
        conditions: [ {} ],
        cashback: {},
        repeat: {},
        steps: [ { conditions: [ {} ] } ],
        recurring: {},
      },

      mail_templates: [],

      defaults: {
        promo: {
          steps: [ { conditions: [ {} ] } ],
        },
        cashback: {
          conditions: [ {} ],
          cashback: {},
          repeat: {},
        },
        retention: {
          steps: [ { conditions: [ {} ] } ],
        },
        achievement: {
          recurring: {},
          steps: [ { conditions: [ {} ] } ],
        },
        journey: {
          steps: [ { conditions: [ {} ] } ],
        }
      },

    }),

    mounted () {
      this.reset()
      // this.item.entity_id = this.projectList[0].entity_id
    },

    methods: {
      filter,
      closeDialog: function () {

        this.$nextTick(function () {
          this.$emit('input', false)
        })
      },
      save: async function () {
        if (await this.$root.$confirm('Confirm', 'Are you sure you want to save?')) {
          this.loading = true
          API.call('/bonus_tools/update.json', this.item, null, this.item.entity_id).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        }
      },
      uniqId: function () {
        this.forID++
        return this.forID
      },
      addBonus: function (i) {
        this.item.bonus[i].push(Vue.observable({ id: this.uniqId() }))
      },
      removeBonusChoice: async function (i) {
        if (await this.$root.$confirm('Confirm', 'Are you sure you want to delete this items?')) {

          let bonuses = cloneDeep(this.item.bonus)
          remove(bonuses, (o, k) => (k == i))

          this.item.bonus = []

          this.$nextTick(function () {
            this.item.bonus = cloneDeep(bonuses)
          })
        }
      },
      loadMailTemplates: function () {
        if (!this.item.entity_id) return

        this.mail_templates = []

        return API.call('/bonus_tools/dictionary/mail_template_list.json', {
          bonus_benefit_id: this.item.benefit_id
        }, null, this.item.entity_id).then(resp => {
          this.mail_templates = resp.data || []
          this.item.mail_templates = resp.selected || []
        }).finally(() => this.loading = false)
      },
      reset: function () {
        this.item = cloneDeep(this.itemInit)
        // this.item.benefit_id = null

        this.$nextTick(function () {
          this.item.type = 'promo'
        })
        this.item.start = moment().format('YYYY-MM-DD HH:mm:ss')
        this.item.end = moment().add(1, 'month').format('YYYY-MM-DD 23:59:59')

      }
    },

    watch: {
      value: function (newValue, oldValue) {
        this.$nextTick(function () {
          this.$emit('input', newValue)
        })

        return oldValue
      },
      init: function () {
        this.reset()
        if (this.init) {
          if (this.init.benefit_id) {
            this.item = cloneDeep(this.init)
          } else {
            this.item.entity_id = cloneDeep(this.init.entity_id)
          }

          this.$nextTick(function () {
            this.$emit('input', true)
          })
        }
      },
      'item.entity_id': function (val) {
        this.loadMailTemplates()
      },
      'item.type': function (val) {

        for (let k in this.item) {
          if (![ 'type', 'title', 'segments', 'bonus', 'start', 'end', 'benefit_id' ].includes(k)) {
            delete this.item[k]
          }
        }

        for (let key in this.defaults[val]) {
          this.item[key] = cloneDeep(this.defaults[val][key])
        }
        this.item = Vue.observable(Object.assign({}, this.item))

        if (this.item.benefit_id) {
          this.item = cloneDeep(this.init)
          // this.$nextTick(() => {
          //   for (let k in this.init) {
          //     if (k != 'type') {
          //       this.$nextTick(() => {
          //         this.item[k] = cloneDeep(this.init[k])
          //       })
          //     }
          //   }
          // })
        } else {
          this.item.bonus = [ [] ]

          this.$nextTick(() => {
            this.item.bonus[0].push({})
          })
        }

        return val
      },
      'item.repeat.period': function () {
        if (this.item.repeat) {
          delete this.item.repeat.days
        }
      }
    },

    computed: {
      dialog: {
        set: function (newValue) {

          this.$nextTick(function () {
            this.$emit('input', newValue)
          })
          return newValue
        },
        get: function () {
          return this.value
        }
      },

      stepsTitle: function () {
        return this.item.type == 'journey' ? 'Steps' : 'Rules'
      },

      days: function () {
        if (!this.item.repeat || !this.item.repeat.period) return []

        return get(find(this.select.periods, (i) => i.value == this.item.repeat.period), 'additional', [])
      },
    }
  }
</script>


